import { TFunction } from 'i18next';
import {
  Dashboard,
  ReceiptLong,
  Autorenew,
  Layers,
  People,
  Extension,
  Settings,
  Link,
} from '@styled-icons/material-outlined';
import { NavItemConfig } from './NavBar.types';
import { PayAuthorizations } from '../../features/authorizations/PayAuthorizations';

export const getNavItems = (
  t: TFunction,
  isAggregatorAccount: boolean
): NavItemConfig[] => [
  {
    title: t('menu.summary'),
    path: '/summary',
    allowedAuthorization: PayAuthorizations.viewDashboard,
    icon: Dashboard,
    hidden: isAggregatorAccount,
  },
  {
    title: t('common.charges'),
    path: '/invoices',
    allowedAuthorization: PayAuthorizations.viewInvoices,
    icon: ReceiptLong,
    children: [
      {
        title: t('common.charges'),
        path: '/invoices',
        exact: true,
        allowedAuthorization: PayAuthorizations.viewInvoices,
      },
      {
        title: t('common.transactions'),
        path: '/invoices/payments',
        allowedAuthorization: PayAuthorizations.viewPayments,
      },
      // TODO: hide for legacy accounts
      {
        title: 'Liquidaciones',
        path: '/invoices/clearings',
        allowedAuthorization: PayAuthorizations.viewClearings,
        hidden: !isAggregatorAccount,
      },
      {
        title: 'Link de pago',
        path: '/invoices/payment-links',
        icon: Link,
        hidden: !isAggregatorAccount,
      },
      {
        title: t('common.reservations'),
        path: '/invoices/reservations',
        allowedAuthorization: PayAuthorizations.viewPayments,
      },
      {
        title: t('common.debt_management'),
        path: '/invoices/debt-invoices',
        allowedAuthorization: PayAuthorizations.viewInvoices,
      },
      {
        title: t('screens.import.generic_link'),
        path: '/invoices/import',
        allowedAuthorization: PayAuthorizations.viewPayments,
      },
    ],
  },
  {
    title: t('menu.subscriptions'),
    path: '/subscriptions',
    allowedAuthorization: PayAuthorizations.viewSubscriptions,
    icon: Autorenew,
    hidden: isAggregatorAccount,
    children: [
      {
        title: t('screens.subscriptions.title'),
        path: '/subscriptions',
        exact: true,
        allowedAuthorization: PayAuthorizations.viewSubscriptions,
      },
      {
        title: t('screens.import.generic_link'),
        path: '/subscriptions/import',
        allowedAuthorization: PayAuthorizations.createBulkSubscriptions,
      },
      {
        title: t('screens.import_variable_subscriptions.link'),
        path: '/subscriptions/update-variable',
        allowedAuthorization: PayAuthorizations.updateBulkSubscriptions,
      },
    ],
  },
  {
    title: t('menu.customers'),
    path: '/customers',
    icon: People,
    children: [
      {
        title: t('screens.customers.title'),
        path: '/customers',
        exact: true,
      },
      {
        title: t('screens.import.generic_link'),
        path: '/customers/import',
        allowedAuthorization: PayAuthorizations.createBulkCustomers,
      },
    ],
  },
  {
    title: t('menu.plans'),
    path: '/plans',
    icon: Layers,
    allowedAuthorization: PayAuthorizations.viewSubscriptions,
    hidden: isAggregatorAccount,
    children: [
      {
        title: t('screens.products.title'),
        path: '/products',
        allowedAuthorization: PayAuthorizations.viewSubscriptions,
      },
      {
        title: t('screens.plans.title'),
        path: '/plans',
        allowedAuthorization: PayAuthorizations.viewSubscriptions,
      },
    ],
  },

  {
    title: t('menu.extras'),
    path: '/extras',
    icon: Extension,
    hidden: isAggregatorAccount,
  },
  {
    title: t('menu.settings'),
    path: '/settings',
    icon: Settings,
    children: [
      {
        title: t('screens.settings.menu.my_business'),
        path: '/settings',
        exact: true,
        allowedAuthorization: PayAuthorizations.manageBusiness,
      },
      {
        title: t('screens.settings.menu.collect_methods'),
        path: '/settings/collect-methods',
        allowedAuthorization: PayAuthorizations.viewCollectMethods,
      },
      {
        title: t('screens.settings.menu.integrations'),
        path: '/settings/integrations',
        allowedAuthorization: PayAuthorizations.viewIntegrations,
      },
      {
        title: t('screens.settings.menu.my_notifications'),
        path: '/settings/notifications',
        allowedAuthorization: PayAuthorizations.manageNotifications,
        hidden: isAggregatorAccount,
      },
      {
        title: t('screens.settings.menu.customer_notifications'),
        path: '/settings/customer-notifications',
        allowedAuthorization: PayAuthorizations.manageNotifications,
        hidden: isAggregatorAccount,
      },
    ],
  },
];
